import { render, staticRenderFns } from "./WorkorderLayout.vue?vue&type=template&id=a8946adc&scoped=true&"
import script from "./WorkorderLayout.vue?vue&type=script&lang=js&"
export * from "./WorkorderLayout.vue?vue&type=script&lang=js&"
import style0 from "./WorkorderLayout.vue?vue&type=style&index=0&id=a8946adc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8946adc",
  null
  
)

export default component.exports